import { IoCheckmarkOutline  } from "react-icons/io5";

const ListSkills = ({ items, isIcon, layout }) => {
  return (
    <ul className={!layout ? 'skill-list' : layout }>
      {items.map((item, index) => (
        (!isIcon) ? <li key={index}>{item}</li> : <li key={index}><IoCheckmarkOutline className="list-icon" /><span>{item}</span></li>
      ))}
    </ul>
  );
};

export default ListSkills;